import { Injectable } from "@angular/core";

import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { CommonFunction } from "../helpers/commonFunction";

@Injectable()
export class SuperAdminSetupService {
  constructor(private http: HttpClient, private commonFunction: CommonFunction) {}

  createUser(userObject: any): Promise<any> {
    userObject = {encryptedToken: this.commonFunction.encrypt(JSON.stringify(userObject))};
    const url = environment.nonValidateUrl + "user/register";
    return this.http
      .post(url, userObject)
      .toPromise()
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error("An error occurred", error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}
